import React from "react";
import Modal from "react-modal";
import { StlViewer } from "react-stl-viewer";
import cancelImg from "../../assets/img/cancel.svg";

const ModelModal = ({ isOpen, onClose, model, themeColor }) => {
    if (!model) return null;

    const modelStyle = {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="3D Model Viewer"
            className="custom-modal dark portfolio-modal"
            overlayClassName="custom-overlay dark"
            closeTimeoutMS={500}
        >
            <div>
                <button className="close-modal" onClick={onClose}>
                    <img src={cancelImg} alt="close icon" />
                </button>

                <div className="box_inner portfolio">
                    <div className="portfolio-modal-header">
                        <h2 className="model-title">
                            {model.name}
                            <span className="title-accent" style={{ color: themeColor }}> 3D</span>
                        </h2>
                        <div className="model-info">
                            <span className="info-badge">
                                <i className="fa fa-file"></i>
                                {formatFileSize(model.size)}
                            </span>
                            <span className="info-badge">
                                <i className="fa fa-cube"></i>
                                STL Format
                            </span>
                        </div>
                    </div>

                    <div className="portfolio-modal-viewer">
                        <StlViewer
                            url={model.url}
                            style={modelStyle}
                            orbitControls
                            shadows={false}
                            showAxes={false}
                            modelProps={{
                                color: themeColor || '#6c757d'
                            }}
                        />

                        {/* Controls Guide */}
                        <div className="viewer-controls-guide">
                            <div className="control-item">
                                <i className="fa fa-mouse-pointer"></i>
                                <span>Rotate: Left Click + Drag</span>
                            </div>
                            <div className="control-item">
                                <i className="fa fa-search"></i>
                                <span>Zoom: Scroll Wheel</span>
                            </div>
                            <div className="control-item">
                                <i className="fa fa-arrows"></i>
                                <span>Pan: Right Click + Drag</span>
                            </div>
                        </div>
                    </div>

                    <div className="portfolio-modal-footer">
                        <a
                            href={model.url}
                            download={model.fileName}
                            className="button"
                            style={{ borderColor: themeColor }}
                        >
                            <span className="button-text">Download STL</span>
                            <span className="button-icon fa fa-download"></span>
                        </a>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

// Helper function to format file size
const formatFileSize = (bytes) => {
    if (bytes === 0) return 'Unknown';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

export default ModelModal;
